import { render } from "./NewBasketPopover.vue?vue&type=template&id=d8458e5c&scoped=true"
import script from "./NewBasketPopover.vue?vue&type=script&lang=js"
export * from "./NewBasketPopover.vue?vue&type=script&lang=js"

import "./NewBasketPopover.vue?vue&type=style&index=0&id=d8458e5c&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8458e5c"]])

export default __exports__